import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { environment } from '../../../environments/environment';
import { ServicesService } from '../../services/services.service';

@Component({
  selector: 'app-product-sublist',
  templateUrl: './product-sublist.component.html',
  styleUrls: ['./product-sublist.component.css']
})
export class ProductSublistComponent implements OnInit {

	public show:boolean = false;
	apiBaseUrl = environment.apiBaseUrl;
	spinLoader = {
		filter : false,
		delete : []
  	};
  	backDiv=true;
    isListData=true;
	isOnePage=false;
	isNoListData=false;

	constructor(private activeroute: ActivatedRoute,private _services: ServicesService, private router: Router) { }

	routePath:string;
	// lists:any;
	productId = '';
	
	ngOnInit() {
		const token = localStorage.getItem('userToken');
		this.activeroute.queryParams.subscribe(params => {
			this.productId = params['pdt'];
		});
		this._services.checkToken('status');
		this.getPageRequest();
	}
	lists:any;
	fields=[
		{
			'field':'component_name',
			'title':'Component Name',
			'width':'80%',
			'code':true,
			'sort':true
		}
	]
	  
	resetSearchField(){
		this.spinLoader['filter'] = true;
		this.getPageRequest();
	}

	getSearchRequest(){
		this.spinLoader['filter'] = true;
		this.getPageRequest();
		}

		sortType : string = '';
		sortField: string = '';
		oldField: string;
		sortingData= {
		'field' : '',
		'type'  : ''
	};

	sortBy(field, event){

		this.oldField = (this.oldField != field) ? this.oldField : field;

		if(typeof this.oldField !== 'undefined'){
			document.getElementById('fa-'+this.oldField).classList.remove('fa-sort-up');
			document.getElementById('fa-'+this.oldField).classList.remove('fa-sort-down');
			document.getElementById('fa-'+this.oldField).classList.add('fa-sort');
		}

		event.target.classList.add('fa');

		this.sortField = field;
		this.sortType = (this.sortType == 'desc') ? 'asc' : 'desc';

		switch(this.sortType){
			case 'desc' : {
			event.target.classList.remove('fa-sort-up');
			event.target.classList.add('fa-sort-down');
			this.oldField = field;
			}
			break;
			case 'asc'  : {
			event.target.classList.remove('fa-sort-down');
			event.target.classList.add('fa-sort-up');
			this.oldField = field;
			}
			break;
			default     : {
			event.target.classList.add('fa-sort');
			}
		}

		this.sortingData = {
			'field' : this.sortField,
			'type'  : this.sortType
		};
			
		this.getPageRequest();
	}

	/*------------------------------Table with Sorting Ends Here--------------------------*/

	/*------------------------------Pagination Integration Starts Here------------------------*/
	currentPage: number = 1;
	loader: boolean = false;
	paginate= {
		'last_page' : 1
	};
	route:string;
	searchFields= [];
	pages: any;
	listData = [];
	editData: Object = {};

	previousPage(){
		if(this.currentPage == 1){
			return;
		}
		this.currentPage = this.currentPage -1;
		this.getPageRequest();
	}

	nextPage() {
		if (this.paginate.last_page-1 < this.currentPage) {
			return;
		}

		this.currentPage ++;
		//console.log(this.currentPage);
		this.getPageRequest();
	}

	changePage(){
		this.currentPage = this.currentPage;
		////console.log(this.currentPage);return;
		this.getPageRequest();
	}

	getPages(n){
		if(n>1){
			this.isOnePage=true;
		}else{
			this.isOnePage=false;
		}
		var data = [];
		for (var i = 1; i <= n; i++) {
			data.push(i);
		}
		this.pages = data;
	}

	/*------------------------------Pagination Integration Starts Here------------------------*/
	totalData:any;
	getPageRequest(){
		this.route  = 'get-component-list';
		////console.log(this.route);return;
		switch(this.route){

			case 'get-component-list' :{
				var data = {
					product_id :this.productId,
					page  : this.currentPage,
					search: {
						'component_name' : this.searchFields['component_name']
					},
					sort: this.sortingData
				};
			}
			break;
		}

		const token = localStorage.getItem('userToken');
		this._services.requestCreator(data, this.route, token).subscribe((result: any) => {
			this.spinLoader['filter'] = false;
			this.isListData=false;
			this.listData = [];
			this.listData = result.result;
			console.log(result.result);
			result.result==''?this.isNoListData=true:true;
			this.totalData = result.paginate.total;
			this.currentPage = result.paginate.current_page;

			if(result.paginate.current_page > result.paginate.last_page){
				this.currentPage = result.paginate.last_page;
			}
			this.getPages(this.paginate.last_page);
			
		});
		return true;
	}



	deleteComponent(id){
		
	}
}
